<template>
  <div class="paginator">
    <div class="md-layout ">
      
      <div class="md-layout md-layout-item paginator-button">
        <span class="paginator-text">
        Viewing <b>{{ page * limit + (count ? 1 : 0) }} - {{page * limit + count}}</b> of <b>{{total}}</b>
        </span>
        <md-button class="prev" :disabled="page==0" @click="$emit('prev')"><md-icon>navigate_before</md-icon></md-button>
        <md-button class="next" :disabled="!pages || page==pages" @click="$emit('next')"><md-icon>navigate_next</md-icon></md-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Paginator",
  props: ['page', 'pages', 'count', 'limit', 'total']
}
</script>
<style lang="scss" scoped>
.paginator-button {
  justify-content: flex-end;
  align-items: center;
}
.prev, .next {
    &.prev {
      margin-right: 0;
    }
    height: 32px;
    min-width: 32px;
    border: 1px solid #C9CED6;
    border-radius: 2px;
}
</style>